module.exports = __webpack_public_path__ + "img/google-play-badge-es.32121626.png";